var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.033,88l4.549-4.549a1.43,1.43,0,0,0,0-2.022L14.57,80.419a1.43,1.43,0,0,0-2.022,0L8,84.967,3.451,80.419a1.43,1.43,0,0,0-2.022,0L.419,81.43a1.43,1.43,0,0,0,0,2.022L4.967,88,.419,92.549a1.43,1.43,0,0,0,0,2.022L1.43,95.581a1.43,1.43,0,0,0,2.022,0L8,91.033l4.549,4.549a1.43,1.43,0,0,0,2.022,0l1.011-1.011a1.43,1.43,0,0,0,0-2.022Z","transform":"translate(0 -80)","fill":"#fff"}));
}

CloseIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
